var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatUnreadLine = function SvgChatUnreadLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 7.833a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M20.833 17V9.417a4.2 4.2 0 0 1-1.666 0v6.75H7.302L5.833 17.32V6.167h10.084a4.2 4.2 0 0 1 0-1.667H5a.833.833 0 0 0-.833.833V20.75l3.712-2.917H20c.46 0 .833-.373.833-.833"
  })));
};
export default SvgChatUnreadLine;